import Title from "@base/Title/Title"

export default Title;
